import { render, staticRenderFns } from "./LearningPathPill.vue?vue&type=template&id=3333865c&scoped=true&"
import script from "./LearningPathPill.vue?vue&type=script&lang=ts&"
export * from "./LearningPathPill.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPathPill.vue?vue&type=style&index=0&id=3333865c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3333865c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3333865c', component.options)
    } else {
      api.reload('3333865c', component.options)
    }
    module.hot.accept("./LearningPathPill.vue?vue&type=template&id=3333865c&scoped=true&", function () {
      api.rerender('3333865c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/LearningPathPill.vue"
export default component.exports